module.exports = __webpack_public_path__ + "static/img/clear.2dfdb9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clear.jpg
// module id = K2RM
// module chunks = 1